/**
 * @generated SignedSource<<dbf141c50615c48263a87ac57abafeeb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserSelectRenderer_Query$variables = {
  doesNotReportUnder?: string | null;
  idIn?: ReadonlyArray<string | null> | null;
  isGuests?: boolean | null;
  isManager?: boolean | null;
  ranked?: boolean | null;
  reportsTo?: string | null;
  reportsUnder?: string | null;
  search?: string | null;
};
export type UserSelectRenderer_Query$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"UserSelect_viewer">;
  };
};
export type UserSelectRenderer_Query = {
  response: UserSelectRenderer_Query$data;
  variables: UserSelectRenderer_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "doesNotReportUnder"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "idIn"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isGuests"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isManager"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ranked"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reportsTo"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reportsUnder"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v8 = {
  "kind": "Variable",
  "name": "doesNotReportUnder",
  "variableName": "doesNotReportUnder"
},
v9 = {
  "kind": "Variable",
  "name": "idIn",
  "variableName": "idIn"
},
v10 = {
  "kind": "Variable",
  "name": "isGuests",
  "variableName": "isGuests"
},
v11 = {
  "kind": "Variable",
  "name": "isManager",
  "variableName": "isManager"
},
v12 = {
  "kind": "Variable",
  "name": "ranked",
  "variableName": "ranked"
},
v13 = {
  "kind": "Variable",
  "name": "reportsTo",
  "variableName": "reportsTo"
},
v14 = {
  "kind": "Variable",
  "name": "reportsUnder",
  "variableName": "reportsUnder"
},
v15 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "relationshipToViewer",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isGuest",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserSelectRenderer_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "UserSelect_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v7/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "UserSelectRenderer_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v16/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "selectUsers",
            "args": [
              (v8/*: any*/),
              {
                "kind": "Literal",
                "name": "first",
                "value": 25
              },
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/)
            ],
            "concreteType": "UserConnection",
            "kind": "LinkedField",
            "name": "users",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserInternalAttributes",
                        "kind": "LinkedField",
                        "name": "internalAttributes",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "manager",
                            "plural": false,
                            "selections": [
                              (v16/*: any*/),
                              (v17/*: any*/),
                              (v18/*: any*/),
                              (v19/*: any*/),
                              (v20/*: any*/),
                              (v21/*: any*/),
                              (v23/*: any*/),
                              (v22/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v16/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v16/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "21399aa6c2b437c6c8a3c7062cb4ee18",
    "id": null,
    "metadata": {},
    "name": "UserSelectRenderer_Query",
    "operationKind": "query",
    "text": "query UserSelectRenderer_Query(\n  $search: String\n  $ranked: Boolean\n  $isGuests: Boolean\n  $isManager: Boolean\n  $reportsTo: ID\n  $reportsUnder: ID\n  $doesNotReportUnder: ID\n  $idIn: [ID]\n) {\n  viewer {\n    ...UserSelect_viewer_1qcINI\n    id\n  }\n}\n\nfragment UserSelect_viewer_1qcINI on Viewer {\n  user {\n    id\n  }\n  selectUsers: users(first: 25, search: $search, reportsTo: $reportsTo, reportsUnder: $reportsUnder, doesNotReportUnder: $doesNotReportUnder, idIn: $idIn, ranked: $ranked, isGuests: $isGuests, isManager: $isManager) {\n    edges {\n      node {\n        id\n        fullName\n        firstName\n        lastName\n        email\n        image\n        relationshipToViewer\n        isGuest\n        internalAttributes {\n          manager {\n            id\n            fullName\n            firstName\n            lastName\n            email\n            image\n            isGuest\n            relationshipToViewer\n          }\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5cc23089aef2efc824e43034e1d35d43";

export default node;
